<template>
  <div ref="incredi-transition">
    <slot />
  </div>
</template>

<script>
export default {
  mounted() {
    const el = this.$refs['incredi-transition'];
    if (this.$attrs.onTransitionstart) el.addEventListener('transitionstart', () => this.$emit('transitionstart'));
    if (this.$attrs.onTransitionend) el.addEventListener('transitionend', () => this.$emit('transitionend'));
    if (this.$attrs.onTransitioncancel) el.addEventListener('transitioncancel', () => this.$emit('transitioncancel'));
  },
};
</script>
